// extracted by mini-css-extract-plugin
export default {"marqueeContainer":"OnboardingMarquee_marqueeContainer__nSiJU"};